export default "<template>\n\n  <KButton>\n    <template #default> Default slot content </template>\n  </KButton>\n\n</template>\n";